import { graphql, compose } from 'react-apollo';
import gql from 'graphql-tag';

const ASSESSMENT_QUERY = gql`
  query($accountId: ID!, $id: ID!) {
    account(id: $accountId) {
      id
      assessment(id: $id) {
        id
        assessmentOptions {
          notificationEmails
          reportTypes
          reportPreferLocale
          jobProfileIdForSingleJobProfileReports
          jobProfileIdsForMultipleJobProfileReports
          sendReportsWhenAssessmentIsComplete
          sendingIndividualReport
          printerFriendlyReport
        }
        subscribed
        locale
        status
        startUrl
        previewInviteUrl
        previewReminderUrl
        startedOn
        submittedOn
        createdOn
        invitedOn
        remindedOn
        declinedOn
        updatedOn
        expiredOn
        scheduledForDeletionOn
        respondent {
          id
          firstName
          lastName
          email
        }
        template {
          id
          title
        }
        compatibleJobProfiles {
          id
          name
        }
      }
    }
  }
`;
const AssessmentDetailWithData = graphql(ASSESSMENT_QUERY, {
  options: (ownProps) => {
    const { aid, assessmentId } = ownProps.match.params;
    return {
      variables: {
        accountId: aid,
        id: assessmentId,
      },
    };
  },
});

const LOCALES_QUERY = gql`
  query SupportLocales {
    locales: activeLocales
  }
`;

const getListLocalesQuery = graphql(LOCALES_QUERY, { name: 'getListLocales' });

export const UPDATE_ASSESSMENT_MUTATE = gql`
  mutation updateAssessment($input: UpdateAssessmentInput!) {
    updateAssessment(input: $input) {
      assessment {
        id
        assessmentOptions {
          notificationEmails
          reportTypes
          jobProfileIdForSingleJobProfileReports
          jobProfileIdsForMultipleJobProfileReports
          sendReportsWhenAssessmentIsComplete
          sendingIndividualReport
          printerFriendlyReport
          reportPreferLocale
        }
      }
    }
  }
`;

const updateAssessmentMutate = graphql(UPDATE_ASSESSMENT_MUTATE, { name: 'updateAssessment' });
export default compose(
  AssessmentDetailWithData,
  getListLocalesQuery,
  updateAssessmentMutate,
);
